import React from 'react';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import { WEBSITE_LOGO_SPEC_KEYS } from '../../utils/website-logo-guidance.util';

/**
 * Recommendations for a logo that looks good in every design, taken from the
 * designs' logo slot: shape and size, background, colors and square marks.
 *
 * @returns The titled list of recommendations.
 */
export const WebsiteLogoSpecs: React.FC = () => {
  const { t } = useI18n();

  return (
    <div className="border-t border-neutral-100 pt-3">
      <Text size="small" weight="medium">
        {t('websites.settings.logo.specs.title')}
      </Text>
      <ul className="mt-1.5 list-disc space-y-1 pl-5">
        {WEBSITE_LOGO_SPEC_KEYS.map((key) => (
          <Text
            as="li"
            key={key}
            size="small"
            color="secondary"
            className="list-item"
            disableAutoLink
          >
            {t(key)}
          </Text>
        ))}
      </ul>
    </div>
  );
};
